import React, { ComponentType } from 'react';
import { MediaManagerApi, useMediaManagerApi } from '../hooks/useMediaManagerApi';
import { MainSource } from '../../constants/Source';

export function withMediaManagerApi<
  TProps extends {
    source: MainSource;
    currentFolder: any;
  },
>(Component: ComponentType<TProps & { mediaManagerApi: MediaManagerApi }>): ComponentType<TProps> {
  return (props) => {
    const { source, currentFolder } = props;
    const api = useMediaManagerApi({ source, currentFolder });

    return <Component {...props} mediaManagerApi={api} />;
  };
}
